export const DEV_COMPATIBLE_STUDIO_ID = 335718;
